var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("circle", { cx: "9", cy: "9", r: "8.25", stroke: "#9B9B9B", strokeWidth: "1.5" }),
    React.createElement("path", { d: "M13.25 9C13.25 11.3824 12.7119 13.5021 11.8799 14.9997 11.0338 16.5228 9.98466 17.25 9 17.25 8.01534 17.25 6.96621 16.5228 6.12008 14.9997 5.28808 13.5021 4.75 11.3824 4.75 9 4.75 6.61764 5.28808 4.49789 6.12008 3.00027 6.96621 1.47725 8.01534.75 9 .75 9.98466.75 11.0338 1.47725 11.8799 3.00027 12.7119 4.49789 13.25 6.61764 13.25 9zM1.125 6L16.875 6M1.125 11.625L16.875 11.625", stroke: "#9B9B9B", strokeWidth: "1.5" })
  );
});